import { ReducerUtil } from 'doctivity-shared/utils';
import { combineReducers } from 'redux';            // ← missing import

import { API_PROVIDER_COMMENTS_DOCUMENTS_TABLE }                from '../actions/providerCommentsActions';
import { API_PROVIDER_COMMENTS_PROVIDERS_TABLE }                from '../actions/providerCommentsActions';
import { API_PROVIDER_COMMENTS_CONTACTS_TABLE }                from '../actions/providerCommentsActions';
import { API_PROVIDER_COMMENTS_LOCATIONS_TABLE }                from '../actions/providerCommentsActions';


export const providerCommentsDocuments = (state = {}, action = null) => {
 
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_PROVIDER_COMMENTS_DOCUMENTS_TABLE,
  );
  
  if (result.actionConsumed) {
    return result.state;      // <<<<<< unwrap
  }
  return state;               // <<<<<< always return current state

};

export const providerCommentsProviders = (state = {}, action = null) => {
 
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_PROVIDER_COMMENTS_PROVIDERS_TABLE,
  );
  
  if (result.actionConsumed) {
    return result.state;      // <<<<<< unwrap
  }
  return state;               // <<<<<< always return current state

};

export const providerCommentsContacts = (state = {}, action = null) => {
 
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_PROVIDER_COMMENTS_CONTACTS_TABLE,
  );
  
  if (result.actionConsumed) {
    return result.state;      // <<<<<< unwrap
  }
  return state;               // <<<<<< always return current state

};

export const providerCommentsLocations = (state = {}, action = null) => {

  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_PROVIDER_COMMENTS_LOCATIONS_TABLE,
  );
  
  if (result.actionConsumed) {
    return result.state;      // <<<<<< unwrap
  }
  return state;               // <<<<<< always return current state

};

/* ────────────────────────────────
   Combined reducer for this slice
   ──────────────────────────────── */
const providerCommentsExtras = combineReducers({
  documents : providerCommentsDocuments,   // state.documents → …
  providers : providerCommentsProviders,   // state.providers → …
  contacts : providerCommentsContacts,   // state.contacts → …
  locations : providerCommentsLocations,   // state.locations → …
});

/* Export it as the default for easy import elsewhere */
export default providerCommentsExtras;
